import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import { SlideItem } from "@limitless/customer/components";
import { TEXT_IMAGE_SLIDE } from "@limitless/customer/utils";
import maintenanceImage from "../assets/maintenance.png";

class MaintenanceScreen extends PureComponent {
    render() {
        const {
            location: { state },
            theme
        } = this.props;

        const { title, headline, imgSrc, primaryColour, contrastColour } = state.content;

        const slide = {
            title: title ? title : "Maintenance in progress",
            imgSrc: imgSrc ? imgSrc : maintenanceImage,
            headline: headline ? headline : "Limitless is performing essential maintenance, check back soon",
            primaryColour: primaryColour ? primaryColour : theme.palette.primary.main,
            contrastColour: contrastColour ? contrastColour : theme.palette.primary.contrastText,
            type: TEXT_IMAGE_SLIDE
        };

        return (
            <div className="llm-view-container">
                <SlideItem slideKey={0} slide={slide} />
            </div>
        );
    }
}

export default withStyles({}, { withTheme: true })(MaintenanceScreen);

MaintenanceScreen.propTypes = {
    history: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired
};
